
import ComboboxObject from "@/interfaces/Base/Combobox/ComboboxObject";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class ComboboxSingleSelectBasic extends Vue {
  @Prop({ required: false, default: "" })
  label!: string;

  @Prop({ required: true })
  selectableItems!: ComboboxObject[];

  @Prop({ required: true })
  selectedItem!: string;

  @Prop({ required: false, default: false })
  loading!: boolean;

  @Prop({ required: false })
  errors!: string[];

  @Prop({ required: false, default: false })
  disabled!: boolean;

  get selectedItemSync() {
    return (
      this.selectableItems.find((item) => item.value === this.selectedItem) ??
      this.selectableItems[0]
    );
  }
  set selectedItemSync(newValue: ComboboxObject) {
    this.$emit("update:selectedItem", newValue.value);
    this.$emit("onChange");
  }

  @Watch("selectedItem")
  selectedItemChanged(): void {
    if (!this.selectedItem) return;
    const item = this.selectableItems.find(
      (item) => item.value === this.selectedItem
    );

    if (item) {
      this.$emit("update:selectedItemText", item.text);
    }
  }
}
